import {
  addContactFailure,
  addContactStart,
  addContactSuccess,
  updateContactFailure,
  updateContactStart,
  updateContactSuccess,
  resetContact,
} from "./contactRedux";
import { mapContactToLeadFields, submitPartial } from "../utils/lmsApi";

// Persist the InterateLeads progressive-capture id. We keep the legacy
// "lead_id" key too because several steps still read it from sessionStorage.
const setPartialId = (partialId) => {
  if (!partialId) return;
  sessionStorage.setItem("partial_id", partialId);
  sessionStorage.setItem("lead_id", partialId);
};

const getPartialId = () =>
  sessionStorage.getItem("partial_id") ||
  sessionStorage.getItem("lead_id") ||
  "";

// ADD CONTACT — the "email step" of the progressive capture.
// Opens (or, for a returning same email, resumes) a capture and returns partial_id.
export const addContact = async (dispatch, contact) => {
  dispatch(addContactStart());

  try {
    const fields = mapContactToLeadFields(contact);
    // Email step is routed by email; do NOT send an old partial_id here so a
    // changed email correctly starts a fresh capture.
    const res = await submitPartial(fields);
    const partialId = res?.data?.partial_id;

    if (partialId) {
      setPartialId(partialId);
      dispatch(resetContact({ contact }));
      dispatch(
        addContactSuccess({
          ...contact,
          lead_id: partialId,
          partial_id: partialId,
        })
      );
    } else {
      dispatch(addContactFailure());
    }
    // Normalize to the { status: 200 } shape callers expect.
    return { status: 200, data: res?.data };
  } catch (err) {
    dispatch(addContactFailure());
  }
};

// UPDATE CONTACT — merge a later field into the same capture (routed by partial_id).
export const updateContact = async (dispatch, contactId, contact) => {
  dispatch(updateContactStart());

  try {
    // Strip control keys and email (continuation path is keyed by partial_id).
    const { step, lead_id, _id, email, partial_id, ...rest } = contact;
    const fields = mapContactToLeadFields(rest);
    const partialId = getPartialId();

    await submitPartial(fields, partialId);
    dispatch(updateContactSuccess(contact));
    return { status: 200 };
  } catch (err) {
    dispatch(updateContactFailure());
  }
};
